import { format } from 'date-fns/esm';
import React, { Component, Fragment } from 'react';
import { FaPlusCircle } from 'react-icons/fa';
import { connect } from 'react-redux';
import { firestoreConnect, isLoaded } from 'react-redux-firebase';
import { compose } from 'recompose';
import { Button, Card, CardBody, CardHeader, Container } from 'shards-react';
import LoadingComponent from '../../../common/loading/LoadingComponent';
import { openModal } from '../../../common/modals/modalActions';

const mapState = state => {
  const profile = state.firebase.profile;
  const companies = state.firestore.ordered.companies;
  const auth = state.firebase.auth;

  return { companies, profile, auth };
};
const actions = {
  openModal
};

class CompanyDashboard extends Component {
  componentDidMount() {
    //console.log(this.props.agents);
  }

  addNewModal = () => {
    //console.log('trigger');
    this.props.openModal('AddNewCompany');
  };
  render() {
    const { companies, openModal } = this.props;
    if (!isLoaded(companies) && companies !== null)
      return <LoadingComponent loading={true} />;
    return (
      <Container fluid className='h-100 my-3'>
        <Fragment>
          {companies && companies.length > 0 ? (
            <Fragment>
              <Card small className='mb-4'>
                <CardHeader className='border-bottom d-flex justify-content-between bg-primary1'>
                  <h5 className='m-0'>Companies</h5>
                  <Button
                    onClick={() => this.addNewModal()}
                    className='align-content-center'
                  >
                    <FaPlusCircle className='mr-2' />
                    <span>Add</span>
                  </Button>
                </CardHeader>
                <CardBody className='p-0 pb-3'>
                  <table className='table mb-0'>
                    <thead className='bg-light'>
                      <tr>
                        <th scope='col' className='border-0'>
                          Name
                        </th>
                        <th scope='col' className='border-0'>
                          Email
                        </th>
                        <th scope='col' className='border-0'>
                          Contacts
                        </th>
                        <th scope='col' className='border-0'>
                          Created
                        </th>
                        <th scope='col' className='text-center'>
                          Details
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {companies &&
                        companies.map(company => (
                          <tr key={company.id}>
                            <td className='col-auto'>{company.name}</td>
                            <td className='col-auto'>{company.email}</td>
                            <td>
                              {company.contactPersons &&
                                company.contactPersons.length}
                            </td>
                            <td className='caption'>
                              {company.createdBy.name} <br />
                              {company.createdBy.date &&
                                format(
                                  company.createdBy.date.toDate(),
                                  'dd MMM yyyy'
                                )}
                            </td>
                            <td className='text-center'>
                              <Button
                                outline
                                onClick={() =>
                                  openModal('AddNewCompany', {
                                    company
                                  })
                                }
                              >
                                View
                              </Button>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Fragment>
          ) : (
            <Fragment>
              No Companies found.
              <Button
                onClick={() => this.addNewModal()}
                className='align-content-center float-right'
              >
                <FaPlusCircle className='mr-2' />
                <span>Add</span>
              </Button>
            </Fragment>
          )}
        </Fragment>
      </Container>
    );
  }
}

export default compose(
  connect(mapState, actions),
  firestoreConnect([
    {
      collection: 'companies',
      storeAs: 'companies'
    }
  ])
)(CompanyDashboard);
